import { Component, Host, Prop, Watch, h } from '@stencil/core';
import type { Tags } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-tags',
  styleUrl: 'cms-tags.scss',
  shadow: true,
})
export class CmsTags {
  private static readonly TAG_PLACEHOLDER = '%TAG%';

  private contentTags: Tags[];
  /**
   * Displayed the Tag Name
   */
  @Prop() tags!: Tags[] | string;

  /**
   * Label, which is used as accessible text. Placeholder {CmsTags.TAG_PLACEHOLDER} can be used to add the current tag to label
   */
  @Prop() label? = CmsTags.TAG_PLACEHOLDER;

  @Watch('tags')
  private tagsWatcher(newValue: Tags[] | string) {
    if (newValue) {
      this.contentTags =
        typeof newValue === 'string' ? JSON.parse(newValue) : newValue;
    }
  }

  private mapTags() {
    if (this.contentTags !== undefined) {
      return this.contentTags.map((tag: Tags) => {
        const { tagName, targetUrl } = tag;
        if (tagName.length > 0 && targetUrl.length > 0) {
          const title = this.label.replace(CmsTags.TAG_PLACEHOLDER, tagName);
          const accessibilityAttributes = {
            'aria-label': title,
            title,
          };
          return (
            <span key={targetUrl} class={'content-tag'}>
              <a
                class={'content-tag-link'}
                href={targetUrl}
                {...accessibilityAttributes}
              >
                <span class={'content-tag-hash'} aria-hidden='true'>
                  #
                </span>
                <span class={'content-tag-name'}>{tagName}</span>
              </a>
            </span>
          );
        }
      });
    }
  }

  componentWillLoad() {
    if (this.tags !== undefined) {
      this.tagsWatcher(this.tags);
    }
  }

  render() {
    return <Host>{this.tags !== undefined ? this.mapTags() : null}</Host>;
  }
}
